module.exports = __webpack_public_path__ + "img/default.f4b58ff.png";